import { useQuery } from "@tanstack/react-query";

import { shop } from "@/api/shop";

export function Entitlements() {
  const { data, isLoading } = useQuery({
    queryKey: ["shop", "entitlements"],
    queryFn: shop.entitlements,
  });

  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="text-2xl font-extrabold tracking-tight text-ink">My add-ons</h1>
      <p className="mt-1.5 text-ink-soft">
        Active add-ons unlock features across the Piggy terminal, mobile app and web.
      </p>
      {isLoading && <p className="mt-3 text-ink-soft">Loading…</p>}
      {data && data.entitlements.length === 0 && (
        <p className="mt-4 rounded-xl border border-line bg-surface p-6 text-ink-mute">
          You don't own any add-ons yet.
        </p>
      )}
      <div className="mt-4 space-y-3">
        {data?.entitlements.map((e) => (
          <div
            key={e.sku_code}
            className="flex items-center justify-between rounded-xl border border-line bg-surface p-5 shadow-card"
          >
            <div>
              <div className="font-semibold text-ink">{e.sku_code}</div>
              <div className="text-sm text-ink-soft">
                {e.entitlement_kind}
                {e.entitlement_ref ? ` · ${e.entitlement_ref}` : ""}
              </div>
            </div>
            <div className="text-right">
              <span className="rounded-full bg-brand-soft px-2.5 py-1 text-xs font-semibold uppercase text-brand-strong">
                {e.status}
              </span>
              <div className="mt-1 text-xs text-ink-mute">
                {e.expires_at ? `until ${new Date(e.expires_at).toLocaleDateString()}` : "lifetime"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
